import React from 'react';
import { formatPrice } from '../../../lib/utils';

const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
export const isManual = (inv) => inv?.source === 'manual';
export const TEST_LABEL = 'TEST – DO NOT FULFILL / DO NOT SHIP';

// Product / service / custom lines of a manual invoice (no room grouping, no shade sizes)
export const ManualLineRows = ({ items }) => (items || []).map((it, i) => (
  <tr key={it.id || i} className="border-b border-neutral-100" data-testid={`invoice-manual-line-${i}`}>
    <td className="py-3">
      <p className="font-medium">{it.name}</p>
      {it.description && <p className="text-sm text-neutral-500">{it.description}</p>}
      <p className="text-xs text-neutral-400">{formatPrice(it.unit_price)} each{it.line_discount > 0 ? ` · discount −${formatPrice(it.line_discount)}` : ''}</p>
    </td>
    <td className="py-3 text-center">{it.quantity}</td>
    <td className="py-3 text-right font-mono">{formatPrice(it.line_total)}</td>
  </tr>
));

export const DiscountRows = ({ inv }) => (inv?.discount_total > 0 ? (
  <>
    <div className="flex justify-between text-sm"><span className="text-neutral-500">Items</span><span className="font-mono">{formatPrice(inv.gross_subtotal)}</span></div>
    <div className="flex justify-between text-sm text-emerald-700" data-testid="invoice-detail-discounts"><span>Discounts</span><span className="font-mono">−{formatPrice(inv.discount_total)}</span></div>
  </>
) : null);

export const manualRowsHtml = (items) => (items || []).map((it) => `<tr><td><strong>${esc(it.name)}</strong>${it.description ? `<br><span style="color:#666;font-size:11px;">${esc(it.description)}</span>` : ''}<br><span style="color:#888;font-size:11px;">$${Number(it.unit_price || 0).toFixed(2)} each${it.line_discount > 0 ? ` · discount -$${it.line_discount.toFixed(2)}` : ''}</span></td><td></td><td>${it.quantity}</td><td style="text-align:right;">$${Number(it.line_total || 0).toFixed(2)}</td></tr>`).join('');
